import { UPDATE_COMMENT_SUCCESS, UPDATE_COMMENT_START } from '../actions/actiontypes'

const INIT_STATE = {
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case UPDATE_COMMENT_START:{
			return {...state};
		}
		case UPDATE_COMMENT_SUCCESS:{
			return {...state, completed:true};
		}
		default:
			return state;
	}
}